const state = {
    workedHours:[],
}

export default state
